<template>
	<component :is="useRenderingMode().isMobileApp ? 'ion-content' : 'div'" class="content">
		<slot />
	</component>
</template>
